import { useMediaQuery } from "react-responsive";
import React, { useState, useEffect } from "react";
// import Lottie from "react-lottie";
import animationData from "./animation.json";

import { FaPhoneAlt, FaEnvelope, FaInstagram, FaTwitter } from "react-icons/fa";

import { FaXTwitter } from "react-icons/fa6";


function AuthorEventBlocks({ isMobile }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? "32px" : "24px",
        width: "100%",
        padding: isMobile ? "24px 16px" : "48px 16px",
        boxSizing: "border-box",
      }}
    >
      {/* Author Spotlight */}
      <div
        style={{
          flex: isMobile ? "unset" : 3,
          width: isMobile ? "100%" : undefined,
          borderRadius: "12px",
          alignSelf: "stretch",
        }}
      >
        <SectionTitle
          title="Author Spotlight"
          width={isMobile ? "45%" : "30%"}
          titleColor="var(--text-neutral)"
        />

        <img
          src="https://images.assettype.com/newslaundry/2026-06-08/41hn9bki/Author.png"
          alt="Author Spotlight"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </div>

      {/* Events */}
      <div
        style={{
          flex: isMobile ? "unset" : 2,
          width: isMobile ? "100%" : undefined,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignSelf: "stretch",
        }}
      >
        <SectionTitle
          title="Events"
          width={isMobile ? "25%" : "14%"}
          titleColor="var(--text-neutral)"
        />

        <img
          src="https://images.assettype.com/newslaundry/2026-06-08/c1v7lsl2/events.png"
          alt="Events"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </div>
    </div>
  );
}



const buttonStyle = {
  padding: "clamp(8px, 2vw, 10px) clamp(14px, 3vw, 18px)",
  border: "none",
  borderRadius: "999px",
  backgroundColor: "#FFF1E8",
  cursor: "pointer",
  fontWeight: "600",
  color: "#000",
  fontSize: "clamp(13px, 2vw, 15px)",
  minHeight: "44px",
  whiteSpace: "nowrap",
};

function LottieBlock() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // preload animation
    if (animationData) {
      setIsLoaded(true);
    }
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  if (!isLoaded) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        aspectRatio: "2",

        overflow: "hidden",

        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        // position: "relative",m
        marginTop: "-3rem",
      }}
    >
      {/* <div
          style={{
            position: "absolute",
            top: "-20px", // crop top

            left:  "-6px",
            // bottom: "-300px",
            right: 0,
          }}
        > */}
      <Lottie options={defaultOptions} width={"120%"} />
      {/* </div> */}
    </div>
  );
}

function SectionTitle({ title, width = "20%", titleColor = "#000" }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        marginBottom: "1rem",
      }}
    >
      <div
        style={{
          color: titleColor,
          fontFamily: "'Lora', serif",
          fontSize: "2.4rem",
          fontWeight: "bold",
        }}
      >
        {title}
      </div>

      <div
        style={{
          borderColor: "#EC2227",
          borderStyle: "solid",
          borderWidth: "2px",
          width,
          marginBottom: "1rem",
        }}
      />
    </div>
  );
}

function HouseBlocks() {
  return (
    <div
      style={{
        background: "#FFF1E8",
        padding: "clamp(16px, 3vw, 40px)",
      }}
    >
      <SectionTitle title="We Welcome All The Reading Criminals:" width="30%" />

      <div
        style={{
          display: "flex",
          gap: "34px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {[
          "kfik7ppm/abon.png",
          "okam17l3/skip.png",
          "6w82q18c/hoard.png",
          "dmxnire5/crack.png",
        ].map((img, index) => (
          <div
            key={index}
            style={{
              flex: "1 1 220px",
              maxWidth: "250px",
              aspectRatio: "1 / 1",
              // overflow: "hidden",
              // borderRadius: "16px",
            }}
          >
            <img
              loading="lazy"
              src={`https://images.assettype.com/newslaundry/2026-06-29/${[
                img,
              ]}`}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function UpcomingBookBlocks() {
  return (
    <div
      style={{
        background: "#FFF1E8",
        padding: "clamp(16px, 3vw, 40px)",
      }}
    >
      <SectionTitle title="Upcoming Books:" width="14%" />

      <div
        style={{
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {[
          "y11ymohg/good-things-.png",
          "cc73i5ia/take-.png",
          "24gxxqx1/time-.png",
        ].map((img, index) => (
          <div
            key={index}
            style={{
              flex: "1 1 260px",
              maxWidth: "380px",
              aspectRatio: "1 / 1",
              overflow: "hidden",
              // borderRadius: "16px",
            }}
          >
            <img
              loading="lazy"
              src={`https://images.assettype.com/newslaundry/2026-06-19/${img}`}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}



function Newsletter({ isMobile }) {


  console.log("isMobile value checking in newsletter", isMobile);
  return (
    <div
      id="newsletter-section"
      style={{
        width: "100%",
        aspectRatio: isMobile ? undefined : "16 / 5",
        // overflow: "hidden",
      }}
      onClick={() => {
        window.location.href = "/book-club";
      }}
    >

      
      <img
        loading="lazy"
        src={
          isMobile
            ? "https://images.assettype.com/newslaundry/2026-07-03/uzmfg9gx/NEWSLETTER.png"
            : "https://images.assettype.com/newslaundry/2026-06-30/ngfd44vp/newsletter.png"
        }
        alt=""
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
}

function ContactUs() {
  return (
    <div
      id="contact-section"
      style={{
        background: "#FFF1E8",
        paddingTop: "clamp(8px, 2vw, 16px)",
        paddingLeft: "clamp(48px, 12vw, 88px)",
      }}
    >
      {/* <SectionTitle title="Contact Us" width="8%" /> */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // gap: "6px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            flex: 1,
            minWidth: "260px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              // gap: "6px",
              marginBottom: "1rem",
            }}
          >
            <div
              style={{
                color: "#000",
                fontFamily: "'Lora', serif",
                fontSize: "3rem",
                fontWeight: "bold",
              }}
            >
              Contact Us
            </div>

            <div
              style={{
                borderColor: "#EC2227",
                borderStyle: "solid",
                borderWidth: "2px",
                width: "24%",
                // marginBottom: "1rem",
              }}
            />
          </div>

          <a
            href="mailto:bookclub@newslaundry.com"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              textDecoration: "none",
              color: "#111827",
              fontWeight: "bold",
            }}
          >
            <FaEnvelope />
            <span>bookclub@newslaundry.com</span>
          </a>

          <a
            href="https://www.instagram.com/newslaundry/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              textDecoration: "none",
              color: "#111827",
              fontWeight: "bold",
            }}
          >
            <FaInstagram />
            <span>https://www.instagram.com/newslaundry</span>
          </a>

          <a
            href="https://x.com/newslaundry"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              textDecoration: "none",
              color: "#111827",
              fontWeight: "bold",
            }}
          >
            <FaXTwitter />
            <span>https://x.com/newslaundry</span>
          </a>
        </div>

        <div
          style={{
            flex: 1,
            minWidth: "280px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            loading="lazy"
            src="https://images.assettype.com/newslaundry/2026-05-28/z6r6226b/contact.png"
            alt=""
            style={{
              width: "100%",
              maxWidth: "300px",
              borderRadius: "20px",
              objectFit: "contain",
            }}
          />
        </div>
      </div>
    </div>
  );
}

// const isMobile = window.innerWidth <= 768;

export function BookClubWebPage() {

  const [isMobileEffect, setIsMobileEffect] = useState(false);


  const isMobileReact = useMediaQuery({
    query: "(max-width: 950px)",
  });

  useEffect(() => {
  const checkIsMobile = () => {
    setIsMobileEffect(window.matchMedia("(max-width: 950px)").matches);
  };

  checkIsMobile();


  return () => {
    
  };
}, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });
  };

const isMobile = isMobileReact || isMobileEffect;


console.log("isMobile value checking", isMobile, isMobileReact , isMobileEffect);

  return (
   <div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: 24,
    width: "100%",
    boxSizing: "border-box",
  }}
>
  {/* Hero */}
  <div
    style={{
      width: "100%",
      position: "relative",
      overflow: "hidden",
    }}
  >
    <img
      src={
        isMobile
          ? "https://images.assettype.com/newslaundry/2026-07-03/clhgwu6f/hero.png"
          : "https://images.assettype.com/newslaundry/2026-06-05/bychsezc/Hero.png"
      }
      alt=""
      style={{
        width: "100%",
        display: "block",
        height: "auto",
      }}
    />

    {isMobile ? (
      <div
        style={{
          position: "absolute",
          right: "5%",
          bottom: "6%",
          display: "flex",
          flexDirection: "column",
          gap: 12,
          alignItems: "flex-end",
        }}
      >
        <button
          onClick={() => scrollToSection("contact-section")}
          style={buttonStyle}
        >
          Contact Us
        </button>

        <button
          onClick={() => scrollToSection("newsletter-section")}
          style={buttonStyle}
        >
          Join our Newsletter
        </button>

        <button
          onClick={() => scrollToSection("current-book-section")}
          style={buttonStyle}
        >
          Explore Our Current Book
        </button>
      </div>
    ) : (
      <>
        <button
          onClick={() => scrollToSection("contact-section")}
          style={{
            ...buttonStyle,
            position: "absolute",
            top: "clamp(28px,6vw,50px)",
            right: "clamp(40px,8vw,64px)",
          }}
        >
          Contact Us
        </button>

        <button
          onClick={() => scrollToSection("newsletter-section")}
          style={{
            ...buttonStyle,
            position: "absolute",
            left: "clamp(40px,8vw,64px)",
            bottom: "clamp(20px,4vw,40px)",
          }}
        >
          Join our Newsletter
        </button>

        <button
          onClick={() => scrollToSection("current-book-section")}
          style={{
            ...buttonStyle,
            position: "absolute",
            right: "clamp(40px,8vw,64px)",
            bottom: "clamp(20px,4vw,40px)",
          }}
        >
          Explore Our Current Book
        </button>
      </>
    )}
  </div>

  {/* About */}
  <div
    style={{
      width: "100%",
      overflow: "hidden",
    }}
  >
       { console.log("About image", isMobile )}
    <img
      src={
        isMobile
          ? "https://images.assettype.com/newslaundry/2026-07-03/wj5y3byx/ABOUT-US.png"
          : "https://images.assettype.com/newslaundry/2026-06-05/efnl7bna/About-Us-.png"
      }
      alt=""
      style={{
        width: "100%",
        display: "block",
        height: "auto",
      }}
    />
  </div>

  <HouseBlocks />

  {/* Current Book */}
  <div
    id="current-book-section"
    style={{
      width: "100%",
      overflow: "hidden",
      cursor: "pointer",
    }}
    onClick={() => {
      window.location.href = "/book-club";
    }}
  >
   { console.log("Current book image", isMobile )}
    <img
      src={
        isMobile
          ? "https://images.assettype.com/newslaundry/2026-07-03/f8pxtrm5/book.png"
          : "https://images.assettype.com/newslaundry/2026-06-19/tux9ylza/book-of-the-month-.png"
      }
      alt=""
      style={{
        width: "100%",
        display: "block",
        height: "auto",
      }}
    />
  </div>

  <UpcomingBookBlocks />
  <AuthorEventBlocks isMobile={isMobile} />
  <Newsletter isMobile={isMobile} />
  <ContactUs />
</div>
  );
}
